import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "45px",
  height: "45px",
  viewBox: "0 0 45 45",
  style: {"enable-background":"new 0 0 45 45"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), { type: "text/css" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".__st0{fill:none}.__st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.__st2{fill:#231F20}.__st3{fill:#121319}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createStaticVNode("<g id=\"__Group_1742_1_\" transform=\"translate(15144.537 -255)\"><g id=\"__Group_1703_1_\" transform=\"translate(-13934.786 157.475)\"><path d=\"M-1183.89,138.52h-6.71v-17.34h6.71V138.52z M-1188.61,136.52h2.71v-13.34h-2.71V136.52z\"></path><rect x=\"-1191.52\" y=\"118.25\" width=\"8.54\" height=\"2\"></rect><rect x=\"-1191.52\" y=\"101.52\" width=\"8.54\" height=\"2\"></rect><rect x=\"-1188.25\" y=\"107.25\" width=\"2\" height=\"10.09\"></rect><polygon points=\"-1185.11,107.48 -1189.4,107.48 -1190.1,104.43 -1184.4,104.43 \t\t\"></polygon></g></g>", 1))
  ]))
}
export default { render: render }